'use client'
import { ProductDocuments } from '@/components/ProductPage/ProductDocuments'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'

type Props = SbBaseBlockProps<{
  heading: string
  description: string
}>

export function ProductDocumentsBlock({ blok }: Props) {
  const { heading, description } = blok

  return <ProductDocuments heading={heading} description={description} />
}
